import { render, staticRenderFns } from "./Secgroup.vue?vue&type=template&id=6ea047bc"
import script from "./Secgroup.vue?vue&type=script&lang=js"
export * from "./Secgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports